import { get, post, deleteApi } from './request'

function getVipAccount(data) {
  return get('/channel_admin/vip_account', data)
}

function addVipAccount(data) {
  return post('/channel_admin/vip_account', data)
}

// 根据vip类型和vip等级查看vip配置
function getVipConfig(params) {
  return get('/channel_admin/vip_config', params)
}

// 保存vip配置
function postVipConfig(data) {
  return post('/channel_admin/vip_config', data)
}
// 获取套餐详细信息
function getPackageConfig(data) {
  return get('/channel_admin/package', data)
}

// 获取所有vip样式列表
function getVipStyleList() {
  return get('/channel_admin/vip/level_imgs')
}

// 获取所有vip类型和vip等级的组合信息
function getVipConfigList(data) {
  return get('/channel_admin/vip_config/list', data)
}

// 删除vip等级
function deleteVipConfig(params) {
  return deleteApi('/channel_admin/vip_config', params)
}
// 修改权益名称
function postVipRightsName(data) {
  return post('/channel_admin/vip/template', data)
}

// 权益内容配置查询
function getEquitytyContentConfig() {
  return get('/channel_admin/vip/template')
}

// 权益内容配置修改
function updateEquitytyContentConfig(data) {
  return post('/channel_admin/vip/template', data)
}

// 普通用户权益配置查询
function getOrdinaryUserRightsConfig() {
  return get('/channel_admin/vip_config/standard')
}

// 普通用户权益配置修改
function updateOrdinaryUserRightsConfig(data) {
  return post('/channel_admin/vip_config/standard', data)
}

// 获取会员详情
function getVipDetails(data) {
  return get('/channel_admin/vip_account/detail', data)
}

// 获取服务详情页面状态下会员的配置列表
function getVipConfigListAtServiceDetail(params) {
  return get('/channel_admin/wxapp_service/user_configs', params)
}

// 获取服务详情页面状态下会员的配置列表
function getVipConfigListAtServiceDetailNew(params) {
  return get('/channel_admin/wxapp_service/user_configs_new', params)
}
// 获取会员开通会员记录
function getStopVipList(params) {
  return get('/channel_admin/vip_account/disabled', params)
}
// 停用会员
function stopVip(data) {
  return post('/channel_admin/vip_account/disabled', data)
}

// 获取会员停用记录
function getStopVipRecordList(params) {
  return get('/channel_admin/vip_account/channel_operate_log', params)
}

export {
  getVipAccount,
  addVipAccount,
  getVipConfig,
  postVipConfig,
  getPackageConfig,
  getVipStyleList,
  getVipConfigList,
  deleteVipConfig,
  postVipRightsName,
  getEquitytyContentConfig,
  updateEquitytyContentConfig,
  getOrdinaryUserRightsConfig,
  updateOrdinaryUserRightsConfig,
  getVipDetails,
  getVipConfigListAtServiceDetail,
  getVipConfigListAtServiceDetailNew,
  getStopVipList,
  stopVip,
  getStopVipRecordList,
}
